"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Measure = function Measure(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.398 83.862l56.67-56.67a2 2 0 0 0 0-2.828l-13.07-13.07a2 2 0 0 0-2.824-.003L11.337 67.792a2 2 0 0 0-.004 2.833L24.57 83.862a2 2 0 0 0 2.828 0zM1.423 67.777L68.188 1.406a2 2 0 0 1 2.824.004l22.955 22.954a2 2 0 0 1 0 2.829L27.398 93.76a2 2 0 0 1-2.828 0L1.418 70.61a2 2 0 0 1 .005-2.833z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.564 49.381l5.657 5.657a1 1 0 0 0 1.414 0l2.122-2.121a1 1 0 0 0 0-1.415L29.1 45.846l-3.536 3.535zm10-10l10.607 10.607a1 1 0 0 0 1.414 0l2.121-2.122a1 1 0 0 0 0-1.414L39.1 35.846l-3.536 3.535zm-20 20l10.607 10.607a1 1 0 0 0 1.414 0l2.121-2.122a1 1 0 0 0 0-1.414L19.1 55.846l-3.536 3.535zm30-30l5.657 5.657a1 1 0 0 0 1.414 0l2.122-2.121a1 1 0 0 0 0-1.415L49.1 25.846l-3.536 3.535zm10-10l10.607 10.607a1 1 0 0 0 1.414 0l2.121-2.122a1 1 0 0 0 0-1.414L59.1 15.846l-3.536 3.535z"
  }))));
};
var _default = exports.default = Measure;